import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';
export const streamEventPublishMessage = defineMessage({
  type: '@assistant/stream-event',
  payloadSchema: t.object({
    eventName: t.string,
    payload: t.record(t.string, t.any)
  })
});